var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class EntityTemp {
    parent;
    flex = {};
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    get flexMap() {
        return observable.map();
    }
    get flexMapPlain() {
        return new Map();
    }
}
__decorate([
    observable
], EntityTemp.prototype, "flex", void 0);
__decorate([
    memoize
], EntityTemp.prototype, "flexMap", null);
__decorate([
    memoize
], EntityTemp.prototype, "flexMapPlain", null);
